import io from 'socket.io-client';

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || 'http://localhost:5002';

const socket = io(SOCKET_URL);

export const subscribeToNotifications = (callback) => {
  socket.on('newNotification', (notification) => {
    callback(notification);
  });

  
};
export const unsubscribeFromNotifications = () => {
  socket.off('newNotification'); // Remove the specific event listener
};
export default socket;
